import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import logoOT from "./../Images/otc-small.png";
import Grid from '@material-ui/core/Grid';
import css from './../Views/AOSupportView.module.css';
import cssCommon from './../Views/Common.module.css';
import OTCloudStatusView from './CloudStatusSettingViewOT';
import OTCloudStatusPreview from './CloudStatusPreviewOT';
import { CloudStatus } from '../Enums/ClodStatusEnum';

class OTSupportView extends Component {

  constructor(props) {
    super(props);

    this.state = {
      Sales_Name: props.data.Login.FirstName + " " + props.data.Login.LastName,
      redraw: false,
      previewValue: CloudStatus.NoIssue
    }
    this.handleDropdownValue = this.handleDropdownValue.bind(this);
  }

  handleDropdownValue(item) {
    this.setState({ previewValue: item });
  }

  render() {
    return (
      <div>
        <Paper className= {this.state.previewValue === CloudStatus.Custom ? css.paper_main : css.paper } elevation={3}>
          <Grid container spacing={1}>
            <Grid item xs={2}>
              <img src={logoOT} alt="logo" className={css.logo}></img>
            </Grid>
            <Grid item xs={4}>
              <div className={css.label}>Post Update to System Status Page</div>
            </Grid>
            <Grid item xs={3}>

            </Grid>
            <Grid item xs={3}>
              <div className={css.label}>{this.state.Sales_Name}</div>
            </Grid>
          </Grid>
          <div className={cssCommon.separator}></div>        
          <OTCloudStatusView data={this.props.data} getSelection={this.handleDropdownValue}></OTCloudStatusView>
        </Paper>
        {this.state.previewValue === CloudStatus.Custom ? null :
          <Paper className={css.paper_grid} elevation={3}>
            <div>
              <div className={css.grid_label}>Preview</div>
            </div>
           <OTCloudStatusPreview  data={this.props.data} previewValue={this.state.previewValue} ></OTCloudStatusPreview>
          </Paper>}
      </div>
    );
  }
}

export default OTSupportView;